module.exports = __webpack_public_path__ + "img/YKM_IOS.4fe11e3f.png";